
    import common from "@/util/common";
    import {computed, ComputedRef, defineComponent, reactive, watch, createApp, toRefs, renderList} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router"
    import utils from '@/util/index';
    import { Toast } from '@souche-ui/vant-next';
    import '@souche-ui/vant-next/es/switch/style';

    interface CheckItemShow {
        Accident: boolean;
        Fire: boolean;
        SoakWater: boolean;
        Appearance: boolean;
        Interior: boolean;
        Lighting: boolean;
        Machine: boolean;
        Power: boolean;
        Bottom: boolean;
        StartUp: boolean;
    }

    interface State {
        entrustList: object[];
        entrustListAll: object[];
        entrustListFlaw: object[];
        needListenScroll: boolean;
        checkItemShow: CheckItemShow;
        onlyFlaw: boolean;
        checkModules: object[];
        hasWarn: boolean;
    }

    export default defineComponent({
        name: "entrust",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                entrustList: [], // 渲染的检测项列表
                entrustListAll: [], // 全部检测项列表
                entrustListFlaw: [], // 存在瑕疵的检测项列表
                needListenScroll: false, // 监听滚动
                checkItemShow: {
                    Accident: false,
                    Fire: false,
                    SoakWater: false,
                    Appearance: false,
                    Interior: false,
                    Lighting: false,
                    Machine: false,
                    Power: false,
                    Bottom: false,
                    StartUp: false,
                },
                onlyFlaw: false,
                checkModules: [],
                hasWarn: true,
            })
            const {query} = useRoute();
            let store = useStore()
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
            // let tocOnlyShowFlaw: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            // watch(tocOnlyShowFlaw, (data: any) => {
            //     state.onlyFlaw = data;
            // })
            function getElementToPageTop (el) {
                if (el.offsetParent) {
                    return getElementToPageTop(el.offsetParent) + el.offsetTop
                }
                else {
                    return el.offsetTop
                }
            }
            function clickTab(id: string) { // 点击委托检测项
                state.needListenScroll = false;
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                const eTopEl: any = document.getElementById(id);
                const topNum = getElementToPageTop(eTopEl);
                state.checkItemShow[id] = true;
                store.dispatch('saveCheckItemShow', {checkItemShow: state.checkItemShow})
                utils.scrollTop(window, sTop, topNum - 60, 500);
                setTimeout(() => {
                    state.needListenScroll = true;
                }, 300);
            }
            // 设置瑕疵检测项
            function setEntrustListToFlaw () {
                let arr = [];
                let checkModules = renderData.value;

                for (let i=0;i<checkModules.length;i++) {
                    let item = checkModules[i];
                    if ((item as any).value !== '0') {
                        (arr as any).push(item);
                    } else if (item.code === 'ecu') {
                        (arr as any).push(item);
                    }
                }
                state.entrustListFlaw = arr;
            }
            // 设置全量检测项
            function setEntrustListToAll () {
                state.entrustListAll = renderData;
            }
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {checkModuleList} = data;
                let haveDefect = false;
                for (let i = 0; i < checkModuleList.length; i += 1) {
                    let item = checkModuleList[i];
                    if (item.defectCount > 0) {
                        haveDefect = true;
                        break;
                    }
                }
                state.hasWarn = haveDefect;
            }, {immediate: true})
            setEntrustListToFlaw();
            setEntrustListToAll();
            state.entrustList = state.entrustListAll;
            let onlyFlaw: ComputedRef<{}> = computed<{}>(() => state.onlyFlaw)
            watch(onlyFlaw, (data: any) => {
                if (data) {
                    state.entrustList = state.entrustListFlaw;
                } else {
                    state.entrustList = state.entrustListAll;
                }
            }) 
            // store.dispatch('saveTocOnlyShowFlaw', false);
            function changeShowFlaw() {
                state.onlyFlaw = !state.onlyFlaw;
                store.dispatch('saveTocOnlyShowFlaw', state.onlyFlaw);
                if (state.onlyFlaw) {
                    Toast('Установлено: показывать только дефекты');
                }
            }
            return {
                state,
                clickTab,
                changeShowFlaw,
                getData
            }
        },
        components: {
            // Switch,
            // Toast
        },
        methods: {
            // changeShowFlaw(data) {
            //     // let store = useStore();
            //     console.log(this.state.onlyFlaw, data);
            //     useStore().dispatch('saveTocOnlyShowFlaw', data)
                
            // }
        }
        
    })
